import {AlarmCenter, AlarmCenterLineModel} from 'src/services/api/endpoints/AlarmCenterEndpoint'

export const LINE_MODEL_OPTIONS: Array<{value: AlarmCenterLineModel; label: string}> = [
  {value: 'AM10', label: 'Compatec AM10'},
  {value: 'AM8', label: 'Compatec AM8'},
  {value: 'PRO', label: 'Continente PRO'},
]

export function formatAlarmCenterLabel(alarmCenter: Pick<AlarmCenter, 'hardwareId' | 'accountNumber'>) {
  return `${alarmCenter.hardwareId} - ${alarmCenter.accountNumber}`
}

export function formatLineModelLabel(lineModel: AlarmCenterLineModel) {
  return LINE_MODEL_OPTIONS.find((option) => option.value === lineModel)?.label ?? lineModel
}

export function isValidHardwareId(value: string) {
  return /^[0-9A-F]{6}$/.test(value)
}

export function isValidAccountNumber(value: string) {
  return /^\d{4}$/.test(value)
}

export function padZoneNumber(value: number) {
  return String(value).padStart(3, '0')
}

export function padPartition(value: string | null | undefined) {
  if (!value) return ''
  return value.padStart(2, '0')
}

export type AlarmCentersSearch = {
  id?: string
  hardwareId?: string
  accountNumber?: string
}

export function parseAlarmCentersSearch(input: string, searchField: string): {search?: AlarmCentersSearch; filter?: {id: number}} {
  const trimmed = input.trim()
  if (!trimmed) return {}

  if (searchField === 'ID' && /^\d+$/.test(trimmed)) {
    return {filter: {id: Number(trimmed)}}
  }

  if (searchField === 'Hardware ID') {
    return {search: {hardwareId: trimmed.toUpperCase()}}
  }

  if (searchField === 'Número da conta') {
    return {search: {accountNumber: trimmed.replace(/\D/g, '')}}
  }

  return {search: {hardwareId: trimmed.toUpperCase()}}
}
